module.exports = __webpack_public_path__ + "img/banner-member-text.f027dacc.png";